<template>
  <div class="company-detail-bd">
    <div class="company-header" v-if="formList">
      <i class="icon icon-fanhuijiantou" @click="jump($route.query.parentPath)" style="cursor: pointer"></i>
      <span class="company-name">{{ data.partnerName }}</span>
    </div>
    <div class="company-msg" v-else>
      <div class="logo-content"></div>
      <div class="msg-content">
        <div class="company-name">{{ data.partnerName }}</div>
        <div class="detail-content">
          <div class="item">
            <div class="key">
              {{ $t('crm_company_detail.zhgly') }}
            </div>
            <div class="val">
              <span class="name">{{ adminMsg.loginName }}</span>
              <span class="phone">{{ adminMsg.mobile }}</span>
              <span class="replace" @click="replace" v-if="propsFuncView.company_change_manager">
                {{ propsFuncView.company_change_manager }}
              </span>
            </div>
          </div>
          <div class="item">
            <div class="key">
              {{ $t('crm_company_detail.ren_zheng_zhuang_tai') }}
            </div>
            <div class="val">
              <span class="status" v-if="getDicValue('real_auth_status', data.realNameState)">{{ getDicValue('real_auth_status', data.realNameState) }}</span>
              <span class="auth" @click="identification" v-if="showAuth && propsFuncView.company_certification">{{ propsFuncView.company_certification }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-content">
      <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
      <div class="tab-content">
        <!-- 基本信息 -->
        <detail-base
          v-if="tabIndex === 0&&!pageFuncView.partner_company_simple"
          :partnerId="companyId"
          :data="data"
        ></detail-base>
        <detail-base-us
          v-if="tabIndex === 0&&pageFuncView.partner_company_simple"
          :partnerId="companyId"
          :data="data"
        ></detail-base-us>
        <!-- 联络人 -->
        <partner-contact v-if="tabIndex === 1" :partnerId="companyId" :partnerOrgId="partnerOrgId" :data="data"></partner-contact>
       <!-- 业务员 -->
       <partner-salesman
          v-if="tabIndex === 14"
          :partnerId="factoryId"
          :partnerOrgId="partnerOrgId"
          :data="data"
        >
        </partner-salesman>
        <!-- 服务区域 2-->
        <partner-serviceArea v-if="tabIndex === 2" :partnerId="companyId" :partnerOrgId="partnerOrgId" :data="data"></partner-serviceArea>
        <!-- 合同 -->
        <partner-contract v-if="tabIndex === 3" :partnerOrgId="partnerOrgId" :partnerId="companyId" :partnerType="partnerType" bizType="service" class="contract"></partner-contract>
        <!-- 设备 -->
        <partner-device v-if="tabIndex === 4" :partnerOrgId="partnerOrgId" partnerType="SC" class="device"></partner-device>
        <!-- 账款 5-->
        <partner-bankCard v-if="tabIndex === 5" :partnerId="companyId" :partnerOrgId="partnerOrgId" bizType="service" partnerType="SC"></partner-bankCard>
        <!-- 租赁方 -->
        <partner-renter v-if="tabIndex === 6" :partnerId="companyId" :partnerOrgId="partnerOrgId" bizType="service" partnerType="CS" orgBy="serviceCompany" :data="data" class="partner-renter" :tableCode="pageFuncView.partner_company_simple?'crm_company_us':'crm_renter'"></partner-renter>
        <!-- 集团客户 8-->
        <partner-customer v-if="tabIndex === 7" :partnerOrgId="partnerOrgId" :partnerId="companyId" partnerType='CO' childOrgType='CO' :data="data"></partner-customer>
        <!--实名证书 -->
        <partner-cert v-if="tabIndex === 8" :data="data" class="cert"></partner-cert>
        <!-- 用户管理 -->
        <user-manage v-if="tabIndex === 10" :orgId="partnerOrgId" orgBy="serviceCompany"></user-manage>
        <!-- 部门管理 -->
        <department-manage v-if="tabIndex === 11" :orgId="partnerOrgId"></department-manage>
        <!-- 设备分配 -->
        <organdevice-manage v-if="tabIndex === 12" :orgId="partnerOrgId"></organdevice-manage>
        <!-- 岗位管理 -->
        <role-manage v-if="tabIndex === 13" :orgId="partnerOrgId"></role-manage>
      </div>
    </div>
    <!-- 跟换管理员-->
    <company-administrators-dialog v-if="dialogVisible" :model="dialogModel" :data="dialogData" @close="dialogVisible = false" @success="getAdministrators"></company-administrators-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partnerContract from '@/pages/crm/components/partnerCommon/partner-contract';
import partnerServiceArea from '@/pages/crm/components/partnerCommon/partner-serviceArea.vue';
import partnerDevice from '@/pages/crm/components/partnerCommon/partner-device';
import partnerContact from '@/pages/crm/components/partnerCommon/partner-contact';
import partnerSalesman from '@/pages/crm/components/partnerCommon/partner-salesman';
import partnerRenter from '@/pages/crm/components/partnerCommon/partner-renter';
import partnerCustomer from '@/pages/crm/components/partnerCommon/partner-customer';
import partnerCert from '@/pages/crm/components/partnerCommon/partner-cert';
import companyAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog';
import partnerBankCard from '@/pages/crm/components/partnerCommon/partner-bankCard.vue';
import detailBaseUs from '@/pages/crm/components/partnerCommon/partner_detail_base_us.vue';
import userManage from '@/pages/base/user/user.vue';
import departmentManage from '@/pages/base/department/department.vue';
import organdeviceManage from '@/pages/base/organdevice/organdevice.vue';
import roleManage from '@/pages/base/role/role.vue';
import detailBase from './company_detail_base.vue';


export default {
  name: 'companyDetail',
  components: {
    userManage,
    departmentManage,
    organdeviceManage,
    roleManage,
    // companyContactsDialog,
    partnerContract,
    partnerDevice,
    partnerBankCard,
    detailBase,
    partnerContact,
    partnerRenter,
    partnerCustomer,
    companyAdministratorsDialog,
    partnerCert,
    partnerServiceArea,
    detailBaseUs,
    partnerSalesman
    // imgDetailDialog
  },
  props: {
    propsFuncView: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tabIndex: null,
      activeName: 'information',
      companyId: '',
      partnerType: '',
      // 管理员信息
      adminList: [],
      data: {},
      // 管理员ID
      partnerId: '',
      partnerOrgId: '',
      administratorsData: [],
      // 联系人
      contactList: [],
      equipmentSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        // pageSize: 40,
        // pageNum: 1,
        bizId: '', //
        isAss: 1, // 是否关联0：未关联 1关联
      },

      // 更换管理员
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      // 联系人组ID用户新增联系人
      bizId: '',
      // 图片预览
      dialogImageUrl: '',
      dialogVisible1: false,

      // 租赁方表格
      tableCode: 'service_hire',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerType: 'SC', // 售后公司service
        partnerId: '',
        businessLicense: '',
      },
      totalRows: null,
      isLoading: false,
      tenterList: [],
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      companyItem: [],
      pageFuncView: {}
    };
  },
  computed: {
    adminMsg() {
      if (this.administratorsData && this.administratorsData.length) {
        const admin = this.administratorsData[0];
        return admin;
      }
      return {};
    },
    tabData() {
      const companyMsg = {
        name: this.$t('crm_company_detail.gong_si_xin_xi'),
        value: 0,
      };
      const contactPerson = {
        name: this.$t('crm_company_detail.lian_luo_ren'),
        value: 1,
      };
      const contentSalesman = {
        name: this.$t('crm_company_detail.ye_wu_yuan'),
        value: 14
      };
      const serviceArea = {
        name: this.$t('crm_company_detail.fu_wu_qu_yu'),
        value: 2,
      };
      const contract = {
        name: this.$t('crm_company_detail.he_tong'),
        value: 3,
      };
      const device = {
        name: this.$t('crm_company_detail.she_bei'),
        value: 4,
      };
      const card = {
        name: this.$t('crm_company_detail.yin_hang_ka'),
        value: 5,
      };
      // 租赁方 （公司类型为代理公司 JV 或 服务公司才显示 JV_SC）
      const leaseholde = {
        name: this.$t('crm_company_detail.zu_lin_fang'),
        value: 6,
      };
      const customers = {
        name: this.$t('crm_company_detail.ji_tuan_ke_hu'),
        value: 7
      };

      const cert = {
        name: this.$t('crm_company_detail.shi_ming_zheng_shu'),
        value: 8,
      };

      const user = {
        name: this.$t('crm_company_detail.yong_hu_guan_li'),
        value: 10,
      };
      const department = {
        name: this.$t('crm_company_detail.bu_men_guan_li'),
        value: 11,
      };
      const organdevice = {
        name: this.$t('crm_company_detail.she_bei_fen_pei'),
        value: 12,
      };
      const role = {
        name: this.$t('crm_company_detail.gang_wei_guan_li'),
        value: 13,
      };


      // if (this.formList && !!this.data.certNo) {
      //   // 租赁方 （公司类型为代理公司 JV 或 服务公司才显示 JV_SC）
      //   if (`${this.data.partnerType}` === 'JV' || `${this.data.partnerType}` === 'JV_SC') {
      //     return [companyMsg, contactPerson, serviceArea, contract, device, card, leaseholde, cert, user, department, organdevice, role];
      //   } else {
      //     return [companyMsg, contactPerson, serviceArea, contract, device, card, cert, user, department, organdevice, role];
      //   }
      // } else if (this.formList && !this.data.certNo) {
      //   // 租赁方 （公司类型为代理公司 JV 或 服务公司才显示 JV_SC）
      //   if (`${this.data.partnerType}` === 'JV' || `${this.data.partnerType}` === 'JV_SC') {
      //     return [companyMsg, contactPerson, serviceArea, contract, device, card, leaseholde, user, department, organdevice, role];
      //   } else {
      //     return [companyMsg, contactPerson, serviceArea, contract, device, card, user, department, organdevice, role];
      //   }
      // } else if (this.data.certNo) {
      //   return [companyMsg, contactPerson, serviceArea, card, cert, user, department, organdevice, role];
      // }
      // return [companyMsg, contactPerson, serviceArea, card, user, department, organdevice, role];

      const arr = [];
      // 美国简版
      if (this.pageFuncView.partner_company_simple) {
        if (this.funcView.partner_detail_msg || this.propsFuncView.base_info) {
          arr.push(companyMsg);
        }
        if (this.funcView.partner_detail_person || this.propsFuncView.company_person) {
          arr.push(contactPerson);
        }
        if (this.propsFuncView.company_salesman) {
          arr.push(contentSalesman);
        }
        if (this.funcView.partner_detail_leaseholde) {
          arr.push(leaseholde);
        }
        if (this.funcView.partner_detail_customers) {
          arr.push(customers);
        }
        if (this.funcView.partner_detail_user) {
          arr.push(user);
        }
        if (this.funcView.partner_detail_department) {
          arr.push(department);
        }
        if (this.funcView.partner_detail_organdevice) {
          arr.push(organdevice);
        }
        if (this.funcView.partner_detail_role) {
          arr.push(role);
        }
      } else {
        // 中国版
        if (this.funcView.partner_detail_msg || this.propsFuncView.base_info) {
          arr.push(companyMsg);
        }
        if (this.funcView.partner_detail_person || this.propsFuncView.company_person) {
          arr.push(contactPerson);
        }
        if (this.propsFuncView.company_salesman) {
          arr.push(contentSalesman);
        }
        if (this.funcView.partner_detail_area) {
          arr.push(serviceArea);
        }
        if (this.funcView.partner_detail_contract) {
          arr.push(contract);
        }
        if (this.funcView.partner_detail_device) {
          arr.push(device);
        }
        if (this.funcView.partner_detail_card) {
          arr.push(card);
        }
        if (this.funcView.partner_detail_leaseholde && `${this.data.partnerType}` === 'JV' || `${this.data.partnerType}` === 'JV_SC') {
          arr.push(leaseholde);
        }
        if (this.funcView.partner_detail_customers) {
          arr.push(customers);
        }
        if (this.funcView.partner_detail_cert && this.data.certNo) {
          arr.push(cert);
        }
        if (this.funcView.partner_detail_user) {
          arr.push(user);
        }
        if (this.funcView.partner_detail_department) {
          arr.push(department);
        }
        if (this.funcView.partner_detail_organdevice) {
          arr.push(organdevice);
        }
        if (this.funcView.partner_detail_role) {
          arr.push(role);
        }
      }
      return arr;
    },
    // 是否来自列表页
    formList() {
      return !!this.getJump('companyId');
    },
    // 是否去认证
    showAuth() {
      return this.data.realNameState === undefined || ['0', '3'].includes(`${this.data.realNameState}`);
    },
  },
  watch: {
    tabData: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          if (!this.tabIndex && this.partnerOrgId) {
            const tabCode = this.getJump('tab');
            if (tabCode === 'user') {
              this.tabIndex = 10;
            } else if (tabCode === 'renter') {
              this.tabIndex = 6;
            } else if (this.tabData && this.tabData.length) {
              this.tabIndex = val[0].value;
            }
          }
        }
      },
    },
  },
  mounted() {
    this.companyId = this.getJump('companyId');
    this.getCompanyDetail();
    // 获取page的看是否简版
    this.getFuncView('/distributor/serviceCompany', (res) => {
      this.pageFuncView = res;
      // 获取详情里面的tab权限
      this.getFuncView();

    });
    // this.getFuncView('/customer/renterDetail');
  },
  methods: {
    identification() {
      this.$router.push({
        path: '/identification',
        query: {
          partnerId: this.companyId,
        },
      });
    },
    replace() {
      const oldAdmin = {};
      // 设置值与列表上的字段一样
      oldAdmin.adminLoginName = this.adminMsg.loginName;
      oldAdmin.adminName = this.adminMsg.realName;
      oldAdmin.adminId = this.adminMsg.userId;
      oldAdmin.partnerOrgId = this.adminMsg.orgId;
      this.dialogData = Object.assign(this.data, oldAdmin);
      this.dialogModel.title = this.$t('crm_company_detail.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },

    handleClick: function () {
      if (this.activeName === 'liaison') {
        // 联系人
        this.getPartnerContact();
      } else if (this.activeName === 'tenter') {
        // 租赁方
        this.getTenter();
      }
    },
    // 获取售后公司详情
    getCompanyDetail: function () {
      return this.$getJSON(apis.partnerInfo, {
        partnerId: this.companyId,
      }).then((res) => {
        this.data = res.data;
        this.companyId = this.data.partnerId;
        this.partnerType = this.data.partnerType;
        // 公司类型
        this.partnerOrgId = res.data.partnerOrgId;
        this.equipmentSearch.bizId = res.data.partnerOrgId;
        // 租赁方ID
        this.formSearch.partnerId = this.companyId;
        // 管理员
        this.getAdministrators();
        // 联系人
        // this.getPartnerContact();
        if (!this.tabIndex) {
          const tabCode = this.getJump('tab');
          if (tabCode === 'user') {
            this.tabIndex = 10;
          } else if (tabCode === 'renter') {
            this.tabIndex = 6;
          } else if (this.tabData && this.tabData.length) {
            this.tabIndex = this.tabData[0].value;
          }
        }
      });
    },
    // 管理员
    getAdministrators() {
      this.$getJSON(`${apis.partnerOrganAdminItem}/${this.partnerOrgId}`).then((res) => {
        if (res.code === 0) {
          res.data = res.data || {};
          if (JSON.stringify(res.data) === '{}') {
            this.administratorsData = [];
          } else {
            this.administratorsData.push(res.data);
          }
        }
      });
    },
    // 联系人
    getPartnerContact() {
      this.$getJSON(apis.partnerContact, {
        partnerId: this.companyId,
      }).then((res) => {
        if (res.code === 0) {
          this.contactList = res.data;
          // 定义联系人的组织id 暂时
        }
      });
    },

    DeleteContact(contactId) {
      this.$showConfirm(this.$('com_delete_confirm'))
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$('com_delete_success'),
                type: 'success',
              });
              this.getPartnerContact();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../style/colors.scss';
.company-detail-bd {
  position: relative;
  padding: 16px;

  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .company-header {
    line-height: 32px;
    padding: 24px 0;
    background: rgba(228, 235, 242, 1);
    .icon {
      font-size: 16px;
      font-weight: bold;
    }
    .company-name {
      font-size: 18px;
      color: #394668;
      font-weight: bold;
      padding-left: 9px;
    }
  }

  .company-msg {
    height: 134px;
    background: #fff;
    margin-top: 16px;
    margin-bottom: 16px;
    flex-shrink: 0;
    .logo-content {
      $r: 40px;
      width: $r;
      height: $r;
      float: left;
      background: #0d9ae0;
      margin-left: 24px;
      margin-top: 24px;
      background-size: 24px 24px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('~@/images/layout/icon_company.png');
      border-radius: 4px;
    }
    .msg-content {
      float: left;
      margin-left: 24px;

      .company-name {
        line-height: 22px;
        font-size: 16px;
        font-weight: bold;
        margin-top: 24px;
      }

      .detail-content {
        overflow: hidden;

        margin-top: 24px;
        .item {
          float: left;
          min-width: 214px;
          font-size: 12px;
          line-height: 16px;
          margin-right: 16px;
          .key {
            color: #98a6ad;
          }
          .val {
            margin-top: 8px;
            color: #495057;
            font-weight: bold;

            > span {
              display: inline-block;
            }

            .phone {
              margin-left: 8px;
            }

            .status {
              margin-right: 20px;
            }
            .replace {
              margin-left: 20px;
              cursor: pointer;
              color: #0d9ae0;
              text-decoration: underline;
            }
            .auth {
              cursor: pointer;
              color: #0d9ae0;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  .company-content {
    // min-height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: auto;
    .tab-content {
      flex: 1;
      overflow: auto;
      height: 0;
      .contract {
        /deep/ .management-wrap {
          height: auto;
          margin-top: 0;
        }
      }

      .device {
        padding: 0;
        /deep/ .product-wrap {
          height: auto;
          margin-top: 0;
        }
      }
    }
    .information {
      .tenter-body {
        height: 500px;
        background-color: #fff;
        padding: 0px 10px 0;
        border: 1px solid #e4e4e4;
        margin-bottom: 90px;
        p {
          color: #262626;
          height: 24px;
          margin-bottom: 20px;
          font-weight: bold;
          line-height: 24px;
          font-size: 16px;
        }
      }
    }

    .liaison {
      padding: 16px 16px 0 16px;
      .liaison-body {
        padding: 30px 0 60px 40px;
        background-color: #fff;
        display: flex;
        ul {
          display: flex;
          flex-flow: wrap;
          li.card {
            margin: 0 20px 20px 0;
            height: 155px;
            width: 300px;
            background-color: #fff;
            padding: 20px 0 0 20px;
            position: relative;
            border: 1px solid rgba(228, 228, 228, 1);
            h3 {
              color: #262626;
              height: 24px;
              line-height: 1;
              margin-bottom: 18px;
            }
            p {
              font-size: 14px;
              line-height: 20px;
              margin-bottom: 6px;
            }
            .operation {
              position: absolute;
              right: 20px;
              bottom: 15px;
              color: $main-color;
              span {
                margin-left: 20px;
                font-size: 12px;
              }
            }
          }
          .add-liaison {
            width: 155px;
            height: 155px;
            font-size: 50px;
            line-height: 155px;
            text-align: center;
            color: #e4e4e4;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(228, 228, 228, 1);
          }
        }
      }
    }
    .tenter {
      padding: 16px 16px 0 16px;
    }
  }

  /deep/ .partner-renter {
    .product-wrap {
      margin-top: 0;
    }
  }
}
</style>
